import { cn } from '@repo/ui/lib/utils';
import { ArrowLeft, Expand, ArrowRight } from 'lucide-react';

import { Button } from '@repo/ui/components/ui/button';

export enum NavigationControlsPosition {
  center,
  bottom,
}

type NavigationControlsProps = {
  isLoading?: boolean;
  position?: NavigationControlsPosition;
  showExpandNavigationControl?: boolean;
  showNavigationControlsOnHover?: boolean;
  onArrowLeftClick?: () => void;
  onExpandClick?: () => void;
  onArrowRightClick?: () => void;
};

export const NavigationControls = ({
  isLoading,
  showExpandNavigationControl,
  showNavigationControlsOnHover,
  position = NavigationControlsPosition.bottom,
  onArrowLeftClick,
  onExpandClick,
  onArrowRightClick,
}: NavigationControlsProps) => {
  const arrowButtonClassName = cn(
    'z-50 rounded-full w-8 h-8 p-2.5 text-white hover:text-white border-white/80 bg-black/60 hover:bg-black/75 shadow-md backdrop-blur-sm',
    {
      'text-black hover:text-black border-black/70 bg-white/90 hover:bg-white':
        isLoading,
    },
  );

  return (
    <section
      className={cn(
        'absolute inset-x-0 bottom-0 z-20 h-14 px-4 flex flex-row justify-between',
        {
          'hidden group-hover/spotlight-media:flex':
            showNavigationControlsOnHover,
          'inset-y-2/4': position === NavigationControlsPosition.center,
          'bottom-0': position === NavigationControlsPosition.bottom,
        },
      )}
    >
      <Button
        className={arrowButtonClassName}
        variant="outline"
        onClick={onArrowLeftClick}
      >
        <ArrowLeft className="w-4 h-4" />
      </Button>

      {showExpandNavigationControl &&
        position === NavigationControlsPosition.bottom && (
          <Button
            className="z-50 rounded-full w-8 h-8 bg-transparent hover:bg-transparent text-white hover:text-white p-2.5 border-0 shadow-none"
            variant="outline"
            onClick={onExpandClick}
          >
            <Expand className="w-4 h-4" />
          </Button>
        )}

      <Button
        className={arrowButtonClassName}
        variant="outline"
        onClick={onArrowRightClick}
      >
        <ArrowRight className="w-4 h-4" />
      </Button>
    </section>
  );
};
